import { ButtonBase, lighten, Link, Stack, SvgIconTypeMap, Theme, Typography } from '@mui/material';
import { OverridableComponent } from '@mui/material/OverridableComponent';
import React from 'react';

//* icons
import ReplyIcon from '@mui/icons-material/Reply';

interface UnderMessageButtonProps {
  icon?: OverridableComponent<SvgIconTypeMap<{}, 'svg'>>;
  text?: string | null;
  type?: 'button' | 'link';
  showDivider?: boolean;
  href?: string;
}

const UnderMessageButton: React.FC<UnderMessageButtonProps> = ({
  icon = ReplyIcon,
  text = '',
  type = 'button',
  showDivider = false,
  href = undefined,
}) => {
  const Content = () => (
    <Stack direction={'row'} alignItems={'center'} spacing={1} lineHeight={1} justifyContent={'center'}>
      <Typography fontSize={14} color="info">
        {text}
      </Typography>
      {icon &&
        React.createElement(icon, {
          color: 'info',
          sx: {
            fontSize: 20,
          },
        })}
    </Stack>
  );

  const containerSx = (theme: Theme) => ({
    py: 1,
    mx: -1.25,
    px: 1.25,
    ...(showDivider && {
      borderBottomWidth: 1,
      borderBottomStyle: 'solid',
      borderBottomColor: lighten(theme.palette.info.main, 0.65),
    }),
  });

  return type === 'link' ? (
    <Link sx={containerSx} href={href} target="_blank" rel="noreferrer">
      <Content />
    </Link>
  ) : (
    <ButtonBase sx={containerSx}>
      <Content />
    </ButtonBase>
  );
};

export default UnderMessageButton;
